
<!--  https://www.tiny.cloud/docs/integrations/vue/ -->
<Editor
  ref="ref_tiny"
  v-bind="$attrs"
  v-on="$listeners"
  api-key="ov5zy6frrpt3llv1ifghjvxwyijd7yjj1xlkxqzumcdje8gu"
  :init="myInit"
/>
